/**
 * Versão da aplicação. Bumpar a CADA release e adicionar item no topo do changelog.
 */
export const APP_NOME = 'AcessaHUOL';
export const APP_VERSION = '0.99.2';
export const APP_DATA = '2026-09-23';

export const APP_CHANGELOG = [
  {
    versao: '0.99.2', data: '2026-09-23',
    itens: [
      'SEGURANCA (achado da revisao de 23/09; o furo ja existia antes desta versao): as funcoes "Fundir" (empresas, motivos e setores) aceitavam ser chamadas sem login, so com a chave publica do site - a trava de perfil deixava passar quando nao havia perfil. Corrigido na migracao 0075: "sem perfil" passa a ser negado e o acesso sem login foi retirado dessas funcoes e das contagens de uso.',
      'Empresas/orgaos: nome nao identificado que ja foi usado em visitas (ex.: "lon.", "Oft.", "nacional") agora pode ser tirado da lista (sugestoes do Jorge, 14/08). Na lixeira (aba Cadastrados) ou no Recusar (aba Pendentes), quem faz escolhe o que acontece com as visitas: apagar o nome delas ou manter o texto digitado; em Cadastrados ha tambem "so esconder" (inativar). Se souber qual e a empresa certa, o caminho continua sendo "Fundir". Requer migracao 0075.',
      'Recusar um motivo ja usado em visitas agora explica que ele nao pode ser apagado e sugere "Fundir" (antes aparecia um erro tecnico).',
      'Balcao: se o gestor fundir ou tirar da lista uma empresa, motivo ou setor enquanto a recepcao esta com a tela aberta, registrar a visita nao da mais erro tecnico em ingles - a lista e atualizada na hora e o sistema pede para escolher de novo, sem perder o que ja foi digitado.',
    ],
  },
  {
    versao: '0.99.1', data: '2026-09-23',
    itens: [
      'Correcao (sugestao do Jorge, 22/09): cadastrar usuario dava "invalid input syntax for type uuid". O formulario tinha um campo tecnico "Auth User ID" logo antes de Colaborador, e era facil digitar o NOME da pessoa ali. O campo saiu do formulario (o vinculo do login continua pelo botao "Ativar acesso", que agora avisa se o texto colado nao tem cara de UID). O Colaborador passou a ser o 1o campo.',
      'Erros de "codigo invalido" (uuid) agora aparecem em portugues claro, em qualquer tela de cadastro.',
      'Datas do historico de versoes corrigidas (0.95 a 0.99 estavam com 22/06; as datas reais vieram do git).',
    ],
  },
  {
    versao: '0.99.0', data: '2026-06-29',
    itens: [
      'Campos de digitar (todos os formularios) ganharam um preenchimento cinza bem sutil, para mostrar onde da para escrever. O campo em que voce esta digitando "acende" em branco. O estado de selecionado (verde) foi preservado.',
    ],
  },
  {
    versao: '0.98.0', data: '2026-06-25',
    itens: [
      'PDF do relatorio agora pagina de verdade (varias paginas). A correcao anterior nao bastou: o corpo da pagina (html/body com overflow escondido do layout de tela cheia) prendia tudo em 1 folha na impressao. Liberado na impressao.',
    ],
  },
  {
    versao: '0.97.0', data: '2026-06-25',
    itens: [
      'Correcao do PDF do relatorio: tabelas grandes estavam sendo cortadas na 1a pagina (o container tinha overflow escondido). Agora o relatorio sai COMPLETO, com as linhas paginando entre as folhas e sem quebrar uma linha no meio.',
    ],
  },
  {
    versao: '0.96.0', data: '2026-06-25',
    itens: [
      'Relatorios: botao "Gerar PDF" (vale para Producao da recepcao e Visitas administrativas). Abre a janela de impressao com o relatorio COMPLETO (todas as linhas, nao so a pagina visivel) e um cabecalho com data; escolha "Salvar como PDF" ou imprima no papel.',
    ],
  },
  {
    versao: '0.95.0', data: '2026-06-25',
    itens: [
      'Visita administrativa: ao reaproveitar um visitante que ja veio (clicar na sugestao por nome/CPF), alem de preencher nome e CPF, agora tambem preenche a Empresa/orgao que ele representou na ultima visita (a recepcionista so ajusta se mudou). A empresa aparece na propria sugestao.',
    ],
  },
  {
    versao: '0.94.0', data: '2026-06-22',
    itens: [
      'Ao trocar de secao, se ela demorar para carregar aparece uma tela de carregamento com a logo (em vez de tela em branco ou do conteudo antigo da secao anterior). Em trocas rapidas nao aparece, para nao piscar.',
    ],
  },
  {
    versao: '0.93.0', data: '2026-06-22',
    itens: [
      'Visita administrativa: "Setor a visitar" e "Motivo da visita" agora ocupam a linha inteira (sozinhos), para o dropdown abrir folgado.',
      'Correcao: o botao de limpar (X) dos campos de BUSCA ficava fora do lugar quando o dropdown abria (descia junto com a lista). Agora fica fixo no campo e o texto nao passa por baixo dele. Vale para todos os campos de busca do sistema.',
    ],
  },
  {
    versao: '0.92.0', data: '2026-06-22',
    itens: [
      'Registrar visita administrativa: formulario tambem em 2 colunas. Nome | CPF, Setor | Motivo e Falar com quem | Empresa/orgao pareados lado a lado; Detalhamento em linha cheia. Mais compacto, menos rolagem (em celular volta para 1 coluna).',
    ],
  },
  {
    versao: '0.91.0', data: '2026-06-22',
    itens: [
      'Telas de cadastro (Colaboradores, Chaves, Empregadores, Usuarios, Setores, Motivos, Empresas) agora em 2 COLUNAS: campos curtos pareados lado a lado e os longos (nome, descricao, e-mail) em linha cheia. Mais compacto, menos rolagem. Em celular volta para 1 coluna automaticamente.',
    ],
  },
  {
    versao: '0.90.0', data: '2026-06-22',
    itens: [
      'Visita administrativa - campos de busca (Empresa/orgao e Setor) nao induzem mais a criar duplicata. Ao digitar "ache" e a empresa ja existir ("Ache Laboratorios..."), ela aparece em destaque para escolher; "cadastrar novo" ficou discreto (cinza, no rodape) e o aviso "sera cadastrado" so aparece DEPOIS que voce escolhe criar. Se houver correspondencia e nada for escolhido, o sistema pede para selecionar em vez de criar um igual.',
    ],
  },
  {
    versao: '0.89.0', data: '2026-06-20',
    itens: [
      'Novo menu "waffle" (grade 3x3, estilo Microsoft 365) no canto superior esquerdo do topo: abre os atalhos para os seus sistemas (AcessaHUOL e AGCOR), cada um em nova aba. A lista de sistemas fica num arquivo unico reusavel (src/config/sistemas.js) para replicar igual nos outros sistemas.',
    ],
  },
  {
    versao: '0.88.0', data: '2026-06-20',
    itens: [
      'Visual: os icones do sistema mudaram de Font Awesome para Phosphor (estilo "regular") - tracos mais finos e modernos, mantendo o mesmo significado em cada um. E uma biblioteca gratuita e auto-hospedavel (sem assinatura). Nao muda nenhum comportamento.',
    ],
  },
  {
    versao: '0.87.0', data: '2026-06-19',
    itens: [
      'Aprovar pendencia (Motivos e Empresas/orgaos): o botao "Aprovar" agora abre a confirmacao do NOME antes de salvar (igual a Setores e Chaves) - da para corrigir a grafia na hora e o sistema avisa se ja existe um parecido/duplicado. Antes so dava para editar depois de aprovar.',
    ],
  },
  {
    versao: '0.86.0', data: '2026-06-19',
    itens: [
      'Motivos e Empresas/orgaos: a aba "Cadastrados" ganhou a coluna "Aprovado em" - mostra a data em que a sugestao pendente foi aprovada (em branco para itens cadastrados direto pela gestao, que nunca passaram por aprovacao, ou aprovados antes desta atualizacao). Requer migracao 0074.',
    ],
  },
  {
    versao: '0.85.0', data: '2026-06-19',
    itens: [
      'Relatorios: o periodo agora abre por padrao em DIA (o dia de hoje), em vez de Semana.',
    ],
  },
  {
    versao: '0.84.0', data: '2026-06-19',
    itens: [
      'Fundir (juntar duplicatas) padronizado: Motivos e Empresas/orgaos agora tem "Fundir" tambem na aba Pendentes (funde a sugestao num cadastrado, movendo as visitas). Setores ganhou "Fundir" nas duas abas - Cadastrados (funde setor A em B, move as visitas; requer migracao 0073) e Pendentes (marca a sugestao como um setor ja existente, sem criar duplicata). O alvo da fusao agora lista so cadastrados (ativos/inativos).',
      'As abas "Pendentes" dos cadastros passaram a usar botoes de ICONE com legenda no hover (Aprovar, Fundir, Recusar, Cadastrar) - igual a aba "Cadastrados".',
    ],
  },
  {
    versao: '0.83.0', data: '2026-06-19',
    itens: [
      'Pesquisa / Historico: o seletor de Chave agora lista TODAS as chaves (antes o autocomplete mostrava no maximo 50, dando a impressao de que faltavam). Os demais campos pesquisaveis passam a avisar "+N - digite para filtrar" quando ha mais opcoes do que cabem na lista (em vez de cortar em silencio). So front.',
    ],
  },
  {
    versao: '0.82.0', data: '2026-06-19',
    itens: [
      'Relatorio Producao da recepcao: os cartoes "sugeridas/aprovadas" de Chaves e Setores deixam de contar as RECUSADAS (passam a ser pendentes + aprovadas), alinhando com motivos/empresas. Requer migracao 0072 (substitui a 0071).',
    ],
  },
  {
    versao: '0.81.0', data: '2026-06-19',
    itens: [
      'Relatorio Producao da recepcao: na tabela "Por recepcionista" e no grafico "Participacao por recepcionista", as colunas/categorias foram juntadas - "Chaves" (cadastrado + avulso) e "Sugestoes" (ativas + passivas). So exibicao; nao precisa de migracao.',
    ],
  },
  {
    versao: '0.80.0', data: '2026-06-19',
    itens: [
      'Relatorio Producao da recepcao: mais dois cartoes no topo, no mesmo padrao funil - "Chaves sugeridas / aprovadas" e "Motivos/empresas sugeridos / aprovados". Requer migracao 0071 (substitui a 0068).',
    ],
  },
  {
    versao: '0.79.0', data: '2026-06-19',
    itens: [
      'Padronizacao das abas de "Pendentes" nos cadastros: Motivos e Empresas/orgaos agora tem aba "Pendentes (N)" separada dos "Cadastrados" (igual a Setores e Colaboradores), com Aprovar/Recusar.',
      'Quem sugeriu: as tabelas de pendentes mostram o recepcionista que originou a pendencia - em Motivos/Empresas (coluna "Sugerido por", requer migracao 0070) e em Colaboradores/avulsos (requer migracao 0069).',
      'Colaboradores > Pendentes (avulsos): novo botao "Dar baixa" (so gestao) para arquivar um avulso que nao da para cadastrar - ele sai da lista. Reversivel: se a mesma pessoa pegar chave de novo depois, reaparece. Requer migracao 0069.',
    ],
  },
  {
    versao: '0.78.0', data: '2026-06-19',
    itens: [
      'Panorama de Visitas - "Quem mais vem": saiu o "volta a cada X dias" (nao fazia sentido em periodos curtos - quem vem 2x no mesmo dia nao "volta a cada 1 dia"). Agora mostra so quantas vezes cada pessoa veio, com o periodo selecionado em destaque acima da lista.',
    ],
  },
  {
    versao: '0.77.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao: os cartoes do topo foram trocados por dois mais claros - "Colaboradores sugeridos / aprovados" e "Setores sugeridos / aprovados" (cada um mostra sugeridos / aprovados, com i explicando). Requer migracao 0068.',
    ],
  },
  {
    versao: '0.76.0', data: '2026-06-18',
    itens: [
      'Pesquisa / Historico: novo filtro por CHAVE (seletor pesquisavel por numero/descricao) - mostra so as movimentacoes daquela chave no periodo. O botao Limpar zera tambem a chave.',
    ],
  },
  {
    versao: '0.75.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao: cartoes do topo ganharam i explicativo. "Sugestoes recusadas" virou "Sugestoes recusadas (chave + setor)" para deixar claro que soma os dois (por isso pode ser maior que o nº de setores). Os 3 cartoes medem coisas diferentes e nao somam entre si - o i explica cada um.',
    ],
  },
  {
    versao: '0.74.0', data: '2026-06-18',
    itens: [
      'Panorama de Visitas - cruzamento "Onde vao x o que buscam": agora CLICA no numero e abre uma janela rolavel com os detalhes AGRUPADOS por frequencia (o mais comum primeiro), em vez do hover que virava parede de texto em periodos longos. Requer migracao 0067 (substitui a 0065).',
    ],
  },
  {
    versao: '0.73.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao: o grafico "registros por hora do dia, por recepcionista" agora mostra a MEDIA por dia trabalhado de cada um (em vez do total acumulado), para comparar entre periodos diferentes. Requer migracao 0066.',
    ],
  },
  {
    versao: '0.72.0', data: '2026-06-18',
    itens: [
      'Relatorios: o periodo abre por padrao em SEMANA (a semana atual).',
    ],
  },
  {
    versao: '0.71.0', data: '2026-06-18',
    itens: [
      'Relatorios: o filtro "Semana" agora usa um seletor de SEMANA (antes pedia escolher um dia). Cada periodo tem o seu seletor proprio: dia, semana, mes ou ano.',
    ],
  },
  {
    versao: '0.70.0', data: '2026-06-18',
    itens: [
      'Relatorios: agora sao SEMPRE atualizados - nao precisa gerar nem salvar. Abas por tipo (Producao da recepcao / Visitas administrativas) + filtro de periodo (Dia, Semana, Mes, Ano - atual e anteriores), renderizando na hora ao escolher.',
    ],
  },
  {
    versao: '0.69.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao: na tabela de chaves avulsas (assunto x recepcionista), o % agora e sobre o TOTAL de chaves que o recepcionista entregou no periodo (cadastradas + avulsas), nao sobre o total de avulsas. Tabela renomeada para "Entregas de chaves avulsas". Coluna "Chaves (avulso)" abreviada para "Chaves (avul.)" para alinhar o i com as demais.',
    ],
  },
  {
    versao: '0.68.0', data: '2026-06-18',
    itens: [
      'Panorama de Visitas - tabela "Onde vao x o que buscam": passar o mouse no numero (pontilhado) mostra os DETALHAMENTOS daquelas visitas (setor x motivo). Requer migracao 0064 (substitui a 0063).',
    ],
  },
  {
    versao: '0.67.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao - tabela de avulsas (assunto x recepcionista): cada celula mostra o numero e, entre parenteses, o % sobre o TOTAL de avulsas daquele recepcionista (ex.: 4 de 47 = 9%). O i no cabecalho explica.',
    ],
  },
  {
    versao: '0.66.0', data: '2026-06-18',
    itens: [
      'Panorama de Visitas: nova tabela CRUZADA "Onde vão x o que buscam" - setores nas linhas, motivos (abreviados, nome completo no i) nas colunas, com Total. Requer migracao 0063 (substitui a 0060: inclui a cadencia + o cruzamento).',
    ],
  },
  {
    versao: '0.65.0', data: '2026-06-18',
    itens: [
      'Relatorio Producao da recepcao: a tabela de entregas avulsas virou CRUZADA - assunto nas linhas e cada RECEPCIONISTA numa coluna (pelo primeiro nome), com coluna Total. Usa a migracao 0061.',
    ],
  },
  {
    versao: '0.64.0', data: '2026-06-18',
    itens: [
      'Devolutiva de sugestoes: alem do aviso, um selo verde no topo ("Voce tem N devolutivas") ao lado do operador - clique para ver. Some quando a pessoa le. Atualiza ao navegar, a cada 30s e em tempo real.',
    ],
  },
  {
    versao: '0.63.0', data: '2026-06-18',
    itens: [
      'Devolutiva de sugestoes: o aviso "Sobre as suas sugestoes" (no login ou ao entrar por PIN) agora mostra tambem as APROVADAS (visto verde), nao so as recusadas - todas de uma vez. So decisoes novas aparecem (as aprovacoes antigas ja entram como vistas). Requer migracao 0062.',
    ],
  },
  {
    versao: '0.62.0', data: '2026-06-18',
    itens: [
      'Relatorio de Visitas virou um PANORAMA de acompanhamento (descritivo, para decisao - NAO investigativo): cartoes (visitas, visitantes diferentes, setor mais procurado, horario de pico), "Quem mais vem" com "volta a cada X dias" e quem procuram, onde vao (setores), o que buscam (motivo), empresas/orgaos e horarios. Removido o "radar de inconsistencias".',
      'Relatorio Producao da recepcao: a tabela "Entregas avulsas por assunto" passou a mostrar o RECEPCIONISTA (so o primeiro nome). Requer migracao 0061.',
    ],
  },
  {
    versao: '0.61.0', data: '2026-06-18',
    itens: [
      'Relatorio de Visitas administrativas: a tabela "Quem mais vem" ganhou a coluna "Volta a cada" - de quanto em quanto tempo cada visitante recorrente costuma voltar (media de dias entre uma visita e a proxima, com a mediana entre parenteses). Gere o relatorio de novo para ver. Requer migracao 0060.',
    ],
  },
  {
    versao: '0.60.0', data: '2026-06-18',
    itens: [
      'Novo relatorio "Visitas - Radar de inconsistencias": cartoes de alerta (pacientes pela recepcao errada, visitantes recorrentes, par empresa x servidor repetido, registros incompletos) + secoes de paciente por setor, recorrentes com cadencia (de quanto em quanto tempo vem e quem procuram), par empresa x servidor, setores mais visitados, horarios de pico (geral x recorrentes) e qualidade do registro por recepcionista. Requer migracao 0059.',
    ],
  },
  {
    versao: '0.59.0', data: '2026-06-18',
    itens: [
      'Visita: "Vai falar com quem?" agora VINCULA ao cadastro de colaboradores - ao escolher um servidor da sugestao, o sistema guarda exatamente quem e (visto verde na lista de hoje). Os "falar com" ja digitados que batem com um unico servidor foram ligados automaticamente. Requer migracao 0058.',
    ],
  },
  {
    versao: '0.58.0', data: '2026-06-18',
    itens: [
      'Visita: Motivo virou lista FECHADA (as 9 categorias) e ganhou um campo aberto "Detalhamento" logo abaixo, para o caso especifico (ex.: "Workshop de Cuidados Paliativos"). O detalhamento e so nota - nao vai para aprovacao. Requer migracao 0057.',
      'Empresas/orgaos: ja vem com uma lista de orgaos comuns cadastrada (TCU, ANVISA, conselhos, UFRN, INSS, Justica Federal...). Requer migracao 0057.',
    ],
  },
  {
    versao: '0.57.0', data: '2026-06-17',
    itens: [
      'Visita: Motivo agora usa 9 CATEGORIAS fixas, com ajuda (?) explicando o que entra em cada. Os motivos ja digitados foram mapeados nas categorias (migracao 0056).',
      'Relatorio de Visitas: motivo agrupado por CATEGORIA (acaba a duplicata) e NOVA secao "Empresa/orgao representado" (antes nao aparecia). Gere o relatorio de novo para ver.',
    ],
  },
  {
    versao: '0.56.0', data: '2026-06-17',
    itens: [
      'Motivos e Empresas (Visitas): novo botao "Fundir" para juntar duplicatas - as visitas da entrada duplicada passam para a que voce escolher manter, e a duplicada e removida (ex.: "Getulio Salles" -> "Getulio Sales Diagnosticos"; dois "GKS" viram um). Requer migracao 0055.',
    ],
  },
  {
    versao: '0.55.0', data: '2026-06-17',
    itens: [
      'Visita: ao escrever Setor/Motivo/Empresa, o sistema sugere o nome certo mesmo com erro de digitacao (ex.: "vasina" -> "Vacina"). Acabou a caixa "nao esta na lista": se o que voce digitar nao casar com um cadastro, ele entende como NOVO e avisa que sera cadastrado e enviado para aprovacao.',
      'Cadastro "Motivos de visita" renomeado para "Motivos" (ja fica no grupo Visitas).',
    ],
  },
  {
    versao: '0.54.1', data: '2026-06-17',
    itens: [
      'Correcao: o icone (i) de ajuda no cabecalho das tabelas aparecia como um quadradinho (peso de fonte sobrescrevia o Font Awesome). Agora aparece certo.',
    ],
  },
  {
    versao: '0.54.0', data: '2026-06-17',
    itens: [
      'Visita administrativa: Motivo da visita e Empresa/órgão representado agora sao LISTAS controladas (dropdown pesquisavel) - acaba a duplicata por digitacao livre. Nao achou? marque "nao esta na lista", escreva, e vai para aprovacao do gestor.',
      '"Vai falar com quem?" sugere os SERVIDORES cadastrados conforme voce digita (pode digitar livre se nao achar).',
      'Novo grupo VISITAS no menu (gestao): Motivos de visita e Empresas/orgaos representados - aprovar, rejeitar, inativar, editar e excluir (excluir so se nunca usado), com badge de pendentes. Requer migracao 0054.',
    ],
  },
  {
    versao: '0.53.0', data: '2026-06-17',
    itens: [
      'Tabelas: cada coluna ganhou um icone (i) no cabecalho que explica o que ela mede (passe o mouse). Aplicado nos relatorios (producao da recepcao e visitas).',
      'Tabelas: colunas com largura proporcional e coerente - os numeros ficam todos do mesmo tamanho e centralizados, deixando a tabela mais agradavel.',
      'Relatorios: texto longo (nome, motivo, setor) corta com "..." e mostra o conteudo inteiro ao passar o mouse (cursor de ajuda) - inclusive nos rotulos dos graficos.',
      'Relatorios: a lista de salvos vem logo apos o filtro, e a exibicao do relatorio fica depois (pode ser FECHADA pelo botao Fechar).',
    ],
  },
  {
    versao: '0.52.0', data: '2026-06-17',
    itens: [
      'Chaves: nova coluna "Pedidas" (quantas vezes a chave foi retirada) + botoes Inativar/Reativar; Excluir so aparece quando a chave nunca foi pedida. Requer migracao 0052.',
    ],
  },
  {
    versao: '0.51.0', data: '2026-06-17',
    itens: [
      'Visitas: motivo, setor e "falar com" sao padronizados (Title Case) na entrada; comando de limpeza do que ja existe (migracao 0051).',
      'Relatorio de Visitas: rotulos corretos (Motivo/Setor/Pessoa, sem "Item"), "nao informado" sai do grafico e vira observacao, grafico + tabela lado a lado, e os recorrentes mostram o que costumam buscar (motivo/setor).',
      'Relatorio da recepcao: aparecem TODOS os recepcionistas (inclusive sem registros).',
    ],
  },
  {
    versao: '0.50.1', data: '2026-06-17',
    itens: [
      'Producao da recepcao: grafico por horario sempre aparece (cai para o agregado se o relatorio for de calculo antigo) e aviso quando precisa regerar apos a migracao 0049. Participacao mantem o nome e empilha por tipo (cadastro/avulso/devolucoes...).',
      'Para quem / quem devolve: o nome da empresa aparece so na primeira parte (mais curto).',
    ],
  },
  {
    versao: '0.50.0', data: '2026-06-17',
    itens: [
      'Novo relatorio VISITAS ADMINISTRATIVAS: por motivo, por setor, quem procuram, horarios de maior visita, visitantes recorrentes e em que horarios os recorrentes costumam vir. Requer migracao 0050.',
      'Participacao por recepcionista: barra empilhada por TIPO (chaves cadastrado/avulso, devolucoes, crachas, visitas, sugestoes ativas/passivas) com legenda.',
      'Excluir relatorio agora confirma a remocao (some da lista de verdade).',
    ],
  },
  {
    versao: '0.49.0', data: '2026-06-17',
    itens: [
      'Relatorio Producao da recepcao: separa entregas a CADASTRADOS x SEM CADASTRO (avulso) por recepcionista, tabela de entregas avulsas POR ASSUNTO (motivo), e sugestoes ATIVAS (botao do usuario: sistema+chave) x PASSIVAS (setor gerado pelo sistema). Graficos com legenda por recepcionista (participacao + horas empilhadas). Devolver: campo de quem devolve replica o nome buscado no filtro (nao o portador). Botoes flutuantes empilhados (nao cobrem mais a paginacao). Requer reexecutar a migracao 0049.',
    ],
  },
  {
    versao: '0.48.0', data: '2026-06-17',
    itens: [
      'Novo modulo RELATORIOS (gestor): gere relatorios mensais padronizados e eles ficam SALVOS para consultar depois. Primeiro modelo: "Producao da recepcao" - por recepcionista: chaves entregues, devolucoes, crachas, visitas e sugestoes, com tabela e graficos (participacao por pessoa e registros por hora) + setores criados via sugestao, recusadas e setores avulsos. So conta recepcionistas. Requer migracao 0049.',
    ],
  },
  {
    versao: '0.47.0', data: '2026-06-17',
    itens: [
      '"Nao identificado" virou uma opcao (caixa de marcar) dentro da entrega E da devolucao avulsa - aparece quando o motivo NAO e "Colaborador nao cadastrado"; marque se nao souber quem e (dispensa o nome), ou digite o nome se souber.',
      'Novo motivo de movimentacao: "Correcao de inconsistencia". Requer migracao 0048.',
    ],
  },
  {
    versao: '0.46.0', data: '2026-06-17',
    itens: [
      'Devolver chave: o campo "quem esta devolvendo" ja vem preenchido com o portador atual (quando cadastrado) - economiza tempo, inclusive ao filtrar por colaborador.',
      'Setores: nova coluna "Visitas" (quantas visitas o setor teve) + botoes Inativar/Reativar; Excluir so aparece quando o setor tem 0 visitas. Requer migracao 0047.',
    ],
  },
  {
    versao: '0.45.0', data: '2026-06-17',
    itens: [
      'Pegar chave: botao discreto "Nao identificado" para quando a recepcao nao consegue identificar quem pegou - registra a entrega avulsa com o motivo certo, sem precisar digitar nome.',
    ],
  },
  {
    versao: '0.44.1', data: '2026-06-17',
    itens: [
      'Lapis de corrigir portador mais visivel (verde, um pouco maior) e sem ser cortado pelo nome. Aparece na chave que esta emprestada, ao lado do nome.',
    ],
  },
  {
    versao: '0.44.0', data: '2026-06-17',
    itens: [
      'Movimentacao: lapis discreto ao lado do nome na chave emprestada para CORRIGIR quem esta com ela (pessoa errada ou nome avulso digitado errado). Registra a correcao no historico (devolve do errado + entrega ao certo), sem apagar nada.',
    ],
  },
  {
    versao: '0.43.1', data: '2026-06-17',
    itens: [
      'Movimentacao: removidos os botoes fixos "Cadastrar chave" e "Sugerir chave" - sugerir usa o botao flutuante (chave) e cadastrar fica em Cadastros > Chaves.',
    ],
  },
  {
    versao: '0.43.0', data: '2026-06-17',
    itens: [
      'KPI de chaves: passa a contar como "avulso" toda movimentacao MARCADA avulsa (entrega ou devolucao), pelo motivo. Antes a devolucao avulsa nao baixava o indicador (gravava o portador). Requer migracao 0046.',
    ],
  },
  {
    versao: '0.42.2', data: '2026-06-17',
    itens: [
      'Correcao: a Empresa do colaborador usava a coluna errada (nome) e quebrava a tela de Usuarios; o certo e "empresa". Agora a empresa aparece em Usuarios e tambem na busca de pessoa (movimentacao/cracha), onde antes nao mostrava.',
    ],
  },
  {
    versao: '0.42.1', data: '2026-06-17',
    itens: [
      'Usuarios: a tabela agora mostra a Empresa (empregador) de cada colaborador.',
    ],
  },
  {
    versao: '0.42.0', data: '2026-06-17',
    itens: [
      'Botao flutuante "Sugerir nova chave" (icone de chave) ao lado do de Sugestoes, para quem usa Chaves - sugerir de qualquer tela.',
      'Visita administrativa: o autocomplete de visitante recorrente tambem funciona ao digitar no campo CPF (antes so no Nome).',
    ],
  },
  {
    versao: '0.41.0', data: '2026-06-16',
    itens: [
      'Cracha: novas abas "Esqueceram hoje" e "Todos os registros" (historico completo, igual ao padrao de Chaves). O historico mostra os 500 mais recentes com busca.',
      'Visita administrativa: "Vai falar com quem?" e "Representa empresa? Qual?" voltaram a ficar um embaixo do outro.',
    ],
  },
  {
    versao: '0.40.0', data: '2026-06-16',
    itens: [
      'KPI de chaves: "Entregas e devolucoes a pessoas cadastradas" - antes media so a ENTREGA (retirada); agora considera tambem o RECEBIMENTO (devolucao), medindo a rastreabilidade nos dois sentidos. Requer migracao 0045.',
    ],
  },
  {
    versao: '0.39.0', data: '2026-06-16',
    itens: [
      'Busca por CPF/matricula agora encontra por INICIO, MEIO ou FIM dos numeros (antes so casava o comeco). Vale na movimentacao, cracha e na busca de visitante. Requer migracao 0044.',
    ],
  },
  {
    versao: '0.38.0', data: '2026-06-16',
    itens: [
      'Busca de pessoa (movimentacao e cracha): a MATRICULA aparece inteira para ajudar a confirmar a pessoa. Para terceirizado, em que a matricula e o proprio CPF, mostra o CPF parcial (***.018.724-**) - confirma sem expor o numero todo no balcao.',
    ],
  },
  {
    versao: '0.37.0', data: '2026-06-16',
    itens: [
      'Recusar sugestao: o gestor agora informa o MOTIVO ao recusar uma chave/setor, e quem sugeriu ve esse motivo na devolutiva ao logar - para saber onde melhorar. Requer migracao 0043.',
      'Visita administrativa: a busca de visitante encontra tambem por CPF (digitando os numeros), nao so por nome.',
      'Aprovar chave E setor usam a analise inteligente de nome (duplicado/generico/teste) - confirmado nos dois.',
    ],
  },
  {
    versao: '0.36.0', data: '2026-06-16',
    itens: [
      'Seguranca de identificacao (movimentacao e cracha): a busca de pessoa agora mostra a EMPRESA junto do nome, AVISA quando ha nomes repetidos ("nome repetido") e a busca por numero ficou precisa - casa os digitos em sequencia (blocos do CPF), em vez de trazer gente sem relacao so por conter os numeros soltos. Reduz o risco de atribuir chave a pessoa errada.',
    ],
  },
  {
    versao: '0.35.0', data: '2026-06-16',
    itens: [
      'Aprovar setor/chave: analise inteligente do nome. Detecta provavel DUPLICADO mesmo com erro de digitacao (ex.: "Manuteçao" ~ "Manutençao" 90%) ou ordem trocada ("204 Sala" = "Sala 204"), nomes de TESTE/rascunho (teste, asdf, aaaa...), genericos e curtos - poupando siglas reais (UTI, CME). Mostra um veredito verde/amarelo/vermelho com o motivo; no vermelho o botao vira "Criar mesmo assim". Continua sem bloquear - voce decide.',
    ],
  },
  {
    versao: '0.34.4', data: '2026-06-16',
    itens: [
      'Menu lateral: os contadores de sugestoes pendentes (Chaves/Setores) e de avulsos a cadastrar agora atualizam SOZINHOS - em tempo real, ao navegar e a cada 30s - e somem quando chegam a zero (antes ficavam presos no ultimo numero ate recarregar).',
    ],
  },
  {
    versao: '0.34.3', data: '2026-06-16',
    itens: [
      'Sugestoes de chave: a aba Pendentes do gestor nao esconde mais a pendencia quando uma migracao de banco ainda nao rodou - o item aparece para aprovar/recusar de qualquer forma (acaba a divergencia entre o numero do menu e a aba).',
    ],
  },
  {
    versao: '0.34.2', data: '2026-06-16',
    itens: [
      'Correcao: na visita administrativa, "Vai falar com quem?", "Representa empresa?" e "Motivo da visita" voltaram a ser salvos - estavam sendo perdidos em silencio.',
      'Limpeza: removida a tela antiga de "Operadores" (tabela legada) - toda gestao de operador e em Usuarios.',
    ],
  },
  {
    versao: '0.34.1', data: '2026-06-16',
    itens: [
      'Correção: sugerir chave (criar/cancelar) voltou a funcionar — o registro do operador apontava para uma tabela antiga e era recusado pelo banco. Requer migração 0042.',
    ],
  },
  {
    versao: '0.34.0', data: '2026-06-16',
    itens: [
      'Devolutiva ao operador: quando o gestor recusa uma sugestão (setor/chave), quem sugeriu vê um aviso ao logar/trocar de operador — some ao dar OK. Requer migração 0041.',
    ],
  },
  {
    versao: '0.33.0', data: '2026-06-16',
    itens: [
      'Login: botão de olho para mostrar/ocultar a senha.',
      'Tela de carregamento bonita (spinner) ao carregar tabelas e listas, em vez do texto simples.',
    ],
  },
  {
    versao: '0.32.0', data: '2026-06-16',
    itens: [
      'Visita administrativa: nova aba "Visitantes" (quem já veio, por CPF, com nº de visitas e última visita).',
      'Editar visitante (gestão): corrige nome/CPF em TODOS os registros daquela pessoa — atalho também na tabela de visitas. Requer migração 0040.',
    ],
  },
  {
    versao: '0.31.2', data: '2026-06-16',
    itens: [
      'Visita administrativa: "Vai falar com quem?" e "Representa empresa?" agora ficam lado a lado.',
    ],
  },
  {
    versao: '0.31.1', data: '2026-06-16',
    itens: [
      'Aprovar setor/chave: além do aviso de duplicado, agora alerta quando o nome é genérico demais (ex.: "Sala", "Almoxarifado") e pede para deixar mais específico.',
    ],
  },
  {
    versao: '0.31.0', data: '2026-06-16',
    itens: [
      'Aprovar setor/chave: o sistema acusa nomes JÁ existentes parecidos (com % de probabilidade) e deixa editar o texto antes de criar — evita duplicados.',
    ],
  },
  {
    versao: '0.30.0', data: '2026-06-16',
    itens: [
      'Visita administrativa: ao digitar o nome, sugere visitantes que já vieram (clique reaproveita nome e CPF). Requer migração 0039.',
      'Visita administrativa: novos campos — com quem vai falar, se representa empresa e motivo da visita.',
    ],
  },
  {
    versao: '0.29.1', data: '2026-06-16',
    itens: [
      'Data/hora sempre no horário do Brasil (America/Fortaleza, UTC-3) na exibição — não depende mais do fuso do computador.',
    ],
  },
  {
    versao: '0.29.0', data: '2026-06-16',
    itens: [
      'Trocar operador: lista ordenada por tipo de acesso (recepção assist. → adm. → supervisor → gestor).',
      'Pesquisa/Histórico: filtro de período com presets (7 dias padrão, este mês, 12 meses, este ano) + personalizado.',
    ],
  },
  {
    versao: '0.28.1', data: '2026-06-16',
    itens: [
      'Se a sessão cair (token expirado ou conta usada em outro lugar), o sistema vai direto para o login em vez de mostrar telas vazias. Os dados nunca são perdidos.',
    ],
  },
  {
    versao: '0.28.0', data: '2026-06-16',
    itens: [
      'Sugestões de setor/chave: texto padronizado na entrada e atualização em tempo real nas telas de Pendentes (requer migração 0038).',
    ],
  },
  {
    versao: '0.27.2', data: '2026-06-15',
    itens: [
      'Tela inicial: gestor abre nos KPIs; recepção abre em Chaves (Registrar Movimentação).',
    ],
  },
  {
    versao: '0.27.1', data: '2026-06-15',
    itens: [
      'O sistema agora sempre abre na tela de Chaves (Registrar Movimentação) para quem tem acesso — inclusive o gestor.',
    ],
  },
  {
    versao: '0.27.0', data: '2026-06-15',
    itens: [
      'Segurança: o PIN limpa sozinho ao errar; após 6 erros, pede para redefinir (sem bloquear); a senha principal trava 15 min após 3 erros. Estado no banco (requer migração 0035).',
    ],
  },
  {
    versao: '0.26.0', data: '2026-06-15',
    itens: [
      'Movimentação: "Pessoa não cadastrada (avulso)" virou "Entrega avulsa" (e "Devolução avulsa" no devolver).',
      'Novos motivos de entrega avulsa. Só "Colaborador não cadastrado" gera sugestão de cadastro e exige a observação (com CPF e empresa). Requer migração 0034.',
    ],
  },
  {
    versao: '0.25.0', data: '2026-06-15',
    itens: [
      'Cadastro de colaborador: o Empregador vem primeiro e o sistema resolve a matrícula sozinho — empregador terceirizado preenche a matrícula com o CPF automaticamente; HU/UFRN é manual. Saiu o botão e o texto.',
      'Cadastro de empregador: marca "Instituição própria (HU/UFRN)?" — o que define quem é terceirizado (requer migração 0033).',
    ],
  },
  {
    versao: '0.24.1', data: '2026-06-15',
    itens: [
      'Telemetria: passa a registrar (anônimo) as ações de emprestar/devolver e seus resultados — o relatório para IA já sai com dados de uso e de erro das chaves.',
    ],
  },
  {
    versao: '0.24.0', data: '2026-06-15',
    itens: [
      'Relatórios: botão "Exportar para IA" — gera um arquivo .md (briefing + dados de uso + prompt) para colar no Claude e receber sugestões de melhoria. Só dados anônimos e agregados.',
    ],
  },
  {
    versao: '0.23.1', data: '2026-06-15',
    itens: [
      'Filtro por colaborador: removido o balão verde (redundante) — agora o nome no campo de busca já indica o filtro; apagar a busca sai dele.',
    ],
  },
  {
    versao: '0.23.0', data: '2026-06-15',
    itens: [
      'Filtro por colaborador: o nome agora fica no campo de busca; apagar a busca (X, Esc ou deletando) sai do filtro. Mais claro para quem é novato.',
    ],
  },
  {
    versao: '0.22.0', data: '2026-06-15',
    itens: [
      'Corrigido: depois de limpar (X) um campo de busca, dava pra escolher de novo só mexendo o mouse — agora reabre a lista na hora. Vale em todas as telas.',
      'Cadastro de colaborador: CPF e Matrícula agora ficam lado a lado.',
      'Devolver chave: ao marcar avulso (pessoa não cadastrada), aparece o Motivo, igual na retirada.',
    ],
  },
  {
    versao: '0.21.0', data: '2026-06-15',
    itens: [
      'Visita administrativa: marque "Setor não está na lista" e escreva livre; ao registrar, o setor vai como sugestão automática ao gestor (sem botão separado).',
    ],
  },
  {
    versao: '0.20.0', data: '2026-06-15',
    itens: [
      'Devolver: campo de quem devolve no topo (igual ao emprestar) e em branco; aviso de com quem a chave está agora é discreto e fica no fim.',
      'Modais: clicar fora fecha — mas só se nada foi digitado (preserva o que você escreveu).',
      'Trocar operador: a bolinha do nome ganhou cor por tipo de acesso (gestor/supervisor/recepção) + legenda.',
    ],
  },
  {
    versao: '0.19.0', data: '2026-06-15',
    itens: [
      'Histórico: colunas inteligentes por tipo. Pessoa e Detalhes mostram o que importa em cada caso (Retirada: quem pegou + motivo; Devolução: quem devolveu + de quem estava).',
    ],
  },
  {
    versao: '0.18.0', data: '2026-06-15',
    itens: [
      'Chaves: botão Imprimir etiquetas — gera os códigos de barras (Code128) das chaves em folha A4 adesiva (3 colunas).',
    ],
  },
  {
    versao: '0.17.0', data: '2026-06-15',
    itens: [
      'Suporte a leitor de código de barras (USB): digitar/bipar o número exato de uma chave + Enter já abre a ação dela.',
    ],
  },
  {
    versao: '0.16.7', data: '2026-06-15',
    itens: [
      'Botão de ação da chave mais compacto no desktop (38px); no toque continua maior (44px). Selo proporcional.',
    ],
  },
  {
    versao: '0.16.6', data: '2026-06-15',
    itens: [
      'Movimentação: o cursor volta para a busca ao fechar QUALQUER janela (emprestar, devolver, cadastrar, sugerir e até cancelar/fechar).',
    ],
  },
  {
    versao: '0.16.5', data: '2026-06-15',
    itens: [
      'Botões de ação: setinha do selo agora aparece (ícone compatível) e Devolver voltou a ser vermelho.',
      'Movimentação: clicar nos filtros (Todos/Emprestado/Disponível) também já joga o cursor na busca.',
    ],
  },
  {
    versao: '0.16.4', data: '2026-06-15',
    itens: [
      'Movimentação: ao voltar para a tela (após emprestar/devolver/cadastrar), o cursor já cai sozinho no campo de busca.',
    ],
  },
  {
    versao: '0.16.3', data: '2026-06-15',
    itens: [
      'Novos botões de ação na movimentação: só ícone (duotone + selo), verde para Pegar e azul para Devolver, nome no hover.',
    ],
  },
  {
    versao: '0.16.2', data: '2026-06-15',
    itens: [
      'Modal de sugestão: a caixa de texto agora ocupa a largura toda (acabou o vazio à direita) e abre mais alta.',
      'Campos com botão de limpar passam a ocupar 100% da largura (corrige a mesma folga em outros formulários).',
    ],
  },
  {
    versao: '0.16.1', data: '2026-06-15',
    itens: [
      'Botões da movimentação: estilo suave (só ícone, nome no hover) e Devolver agora é AZUL (era vermelho).',
    ],
  },
  {
    versao: '0.16.0', data: '2026-06-15',
    itens: [
      'Telemetria de uso (anônima e agregada) — captura inicial: telas abertas e mapa de navegação. Sem dados pessoais.',
      'Base para o painel Uso do sistema e o Exportar para IA (requer rodar a migração 0032 no Supabase).',
    ],
  },
  {
    versao: '0.15.0', data: '2026-06-15',
    itens: [
      'KPIs: cada indicador tem um ícone (i) explicando o que mede, como é calculado e a direção da meta.',
      'KPIs: velocímetros mais compactos, deixando o painel mais enxuto.',
    ],
  },
  {
    versao: '0.14.0', data: '2026-06-15',
    itens: [
      '"Em breve" no menu agora fica discreto (esmaecido + relógio), igual ao "sem acesso".',
      'Movimentação: "Cadastrar chave" abre a janela de cadastro direto (atalho), sem ir ao módulo Chaves.',
    ],
  },
  {
    versao: '0.13.0', data: '2026-06-15',
    itens: [
      'Botão de limpar (x) nos campos digitáveis (incluindo Para quem? e nomes) — aparece quando preenchido e já foca pra digitar de novo.',
    ],
  },
  {
    versao: '0.12.0', data: '2026-06-15',
    itens: [
      'Movimentação: ao buscar por colaborador e emprestar, o nome já vem preenchido (editável). Ao devolver, vem quem está com a chave.',
    ],
  },
  {
    versao: '0.11.1', data: '2026-06-15',
    itens: [
      'Corrige select pesquisável dentro de modais (setor na Visita, colaborador no Crachá, cadastros): a lista agora flui no modal em vez de ser cortada.',
    ],
  },
  {
    versao: '0.11.0', data: '2026-06-15',
    itens: [
      'Movimentação: a busca por colaborador virou parte do próprio campo de busca (sugere "ver chaves dos últimos 6 meses") — sem botão solto.',
      'Sugestões do sistema em tempo real para o gestor (Configurações > Sugestões).',
    ],
  },
  {
    versao: '0.10.0', data: '2026-06-15',
    itens: [
      'Botão flutuante de sugestão (qualquer usuário). Gestor avalia em Configurações > Sugestões (implementar/rejeitar; histórico).',
      'Versão do sistema exibida ao lado do avatar.',
    ],
  },
  {
    versao: '0.9.0', data: '2026-06-15',
    itens: [
      'Movimentação: filtro "Por colaborador" — digite o nome e veja as chaves que ele pegou nos últimos 6 meses (avisa se não pegou nenhuma).',
    ],
  },
  {
    versao: '0.8.4', data: '2026-06-15',
    itens: [
      'Menu: itens sem acesso aparecem desabilitados (selo "sem acesso") em vez de sumir; clique explica que falta acesso pelo perfil.',
      'Grade de chaves limitada a 5 colunas no máximo (menos apertado).',
    ],
  },
  {
    versao: '0.8.3', data: '2026-06-15',
    itens: [
      'Removido o lembrete periódico de operador (empilhava e confundia).',
      'Troca de operador redesenhada: busca por nome, avatares e botão Confirmar.',
      'PIN auto-confirma ao voltar a ser você (sem precisar clicar).',
    ],
  },
  {
    versao: '0.8.2', data: '2026-06-15',
    itens: [
      'Rede de segurança: atualização periódica (30s) nas telas de balcão caso o tempo real falhe; atualiza ao voltar o foco na aba.',
    ],
  },
  {
    versao: '0.8.1', data: '2026-06-15',
    itens: [
      'Cadastro de colaborador: aviso e botão "Usar CPF como matrícula" (terceirizado).',
    ],
  },
  {
    versao: '0.8.0', data: '2026-06-15',
    itens: [
      'Tempo real: Movimentação, Crachá e Visita administrativa atualizam sozinhas quando outra estação registra algo (Supabase Realtime).',
      'Publicado na Cloudflare Pages.',
    ],
  },
  {
    versao: '0.7.0', data: '2026-06-14',
    itens: [
      'Visita administrativa: recepção pode sugerir novo setor (gestor aprova e cria); gestor cadastra na hora.',
      'Setores: aba Pendentes para aprovar sugestões; badge no menu.',
      'Controle de versão ativo: ao atualizar (inclui mudanças de banco), versões antigas pedem para recarregar.',
    ],
  },
  {
    versao: '0.6.1', data: '2026-06-14',
    itens: [
      'Crachá e Visita administrativa: mostram quem registrou (Registrado por).',
      'Topo mais limpo (sem ícone/nome do módulo); novas logos AcessaHUOL.',
      'Aviso de acesso suspenso abre janela com a lista (nome, desde quando e prazo).',
    ],
  },
  {
    versao: '0.6.0', data: '2026-06-14',
    itens: [
      'Aviso de colaboradores com acesso suspenso ao lado do operador (com contagem).',
      'Bloqueio com aviso ao tentar entregar chave a colaborador afastado.',
      'Crachá e Visita administrativa: cadastro em janela (modal); logo do módulo no topo.',
      'KPIs em 3 colunas; invariante de suspensão garantido por trigger no banco.',
    ],
  },
  {
    versao: '0.5.0', data: '2026-06-14',
    itens: [
      'Acesso suspenso do colaborador (judicial/disciplinar/administrativo): gestão marca, recepção visualiza; fica inativo enquanto durar.',
      'Empregadores: quantidade de colaboradores entre parênteses e ação de inativar/substituir empresa (reatribui os colaboradores).',
      'KPI de Crachá: reincidência mensal (mesmo colaborador esquece 2+ vezes no mês).',
      'Setores com grafia padronizada; Pesquisa: coluna "Pessoa" virou "Retirada por".',
    ],
  },
  {
    versao: '0.4.0', data: '2026-06-14',
    itens: [
      'Módulo Crachá: registra colaborador que esqueceu o crachá (lista do dia).',
      'Módulo Visita administrativa: visitante externo com nome, CPF e setor (Resolução SEI 45); sem baixa de saída.',
      'Novo cadastro de Setores (Cadastros), populado com a lista da Resolução SEI 45.',
    ],
  },
  {
    versao: '0.3.0', data: '2026-06-14',
    itens: [
      'Dashboard em velocímetros: indicadores de atendimento (entregues a cadastrados; devolvidas no mesmo dia).',
      'Filtro Não atendidos / Atendidos (inicia em Não atendidos) e metas configuráveis pelo GESTOR.',
      'Listas grandes (>1000) agora paginam no carregamento; menu Crachá (em breve).',
    ],
  },
  {
    versao: '0.2.0', data: '2026-06-14',
    itens: [
      'Rebranding para AcessaHUOL (Gestão de Acessos, Chaves e Visitas). Foco atual: Controle de Chaves.',
      'Movimentação em cartões; empréstimo avulso com motivo; histórico de retirada/devolução.',
      'Troca rápida de operador por PIN; campos de busca pesquisáveis; padronização de nomes.',
    ],
  },
  {
    versao: '0.1.0', data: '2026-06-13',
    itens: ['Estrutura inicial do projeto (Vite + Supabase + Netlify).'],
  },
];
